export default __webpack_public_path__ + "static/media/monitors-img.cd048258.png";